/*
 * View for the topic label modal
 */

define(["marionette", "./template/kbRoleDetailsModalTemplate.html"], function (
  Marionette,
  KbRoleDetailsModalTemplate,
) {
  "use strict";

  var KbRoleDetailsModalView = {};

  KbRoleDetailsModalView.kbRoleDetailsModalLayout = Marionette.Layout.extend({
    template: KbRoleDetailsModalTemplate,
    regions: {
      kbRoleDetails: "#kbRoleDetails",
      basicKbRoleInfoDiv: "#basicKbRoleInfoDiv",
      contentAndLearnerDiv: "#contentAndLearnerDiv",
      authoringRulesDiv: "#authoringRulesDiv",
      touchpointMapDiv: "#touchpointMapDiv",
      localeMapDiv: "#localeMapDiv",
    },
    triggers: {
      "click #deleteKbRole": "delete:kbRole",
    },
  });

  return KbRoleDetailsModalView;
});
